<template>
	<b-modal id="account-login" v-model="show" no-fade hide-footer hide-header>

		<b-tabs content-class="pt-3" nav-class="modal-header p-0">
			
			<template v-slot:tabs-end>
				<b-button-close @click="show = false"/>
			</template>

			<b-tab title="Login">
				<form @submit.prevent>
					<div class="form-group">
						<label>Email address</label>
						<input type="email" class="form-control" v-model="username">
					</div>
					<div class="form-group">
						<label>Password</label>
						<input type="password" class="form-control" v-model="password">
					</div>
					<b-alert variant="danger" :show="error">
						{{errorMessage}}
					</b-alert>
					<div class="form-group text-right">
						<button class="btn btn-primary" @click="login()" v-if="!loading">Login</button>
						<button class="btn btn-primary" type="button" disabled v-if="loading">Loading...</button>
					</div>
				</form>
			</b-tab>

			<b-tab title="Register">
				<form @submit.prevent>
					<div class="form-group">
						<label for="exampleInputEmail1">Email address</label>
						<input type="email" class="form-control" v-model="username" id="registration_email">
						<div class="invalid-feedback">
							Please enter an email address.
						</div>
					</div>
					<div class="form-group">
						<label for="exampleInputPassword1">Password</label>
						<input type="password" class="form-control" v-model="password">
						<div class="invalid-feedback">
							Please enter a password.
						</div>
					</div>
					<div class="form-group">
						<label for="exampleInputPassword1">Confirm Password</label>
						<input type="password" :class="passwords_match?'form-control':'form-control is-invalid'" v-model="password_confirm">
						<div class="invalid-feedback">
							Passwords do not match.
						</div>
					</div>
					<div class="form-group text-right">
						<button class="btn btn-primary" @click="register()" :disabled="!reg_complete" v-if="!loading">Register</button>
						<button class="btn btn-primary" type="button" disabled v-if="loading">Loading...</button>
					</div>
				</form>
			</b-tab>

		</b-tabs>

	</b-modal>
</template>

<script>
export default {
	data: function(){
		return {
			'username': '',
			'password': '',
			'password_confirm': '',
			'grant_type': 'password',
			'client_id': 2,
			'client_secret': '5YwkvIHktrSmI3SkZKVBbfMCps34PLvGThCjKYGj'
		}
	},
	computed: {
        email_entered: function(){
			return this.username != ''
        },
        password_entered: function(){
			return this.password != ''
        },
        passwords_match: function(){
			return this.password === this.password_confirm
        },
        reg_complete: function(){
			return this.password_entered && this.passwords_match && this.email_entered
		},
		show: {
			get: function(){
				return this.$store.state.modals.account.login.show
			},
			set: function(){
				this.$store.dispatch('modals/hideLogin')
			}
		},
		loading: function(){
			return this.$store.state.account.loading
		},
		error: function(){
			return this.$store.state.modals.account.error
		},
		errorMessage: function() {
			return this.$store.state.modals.account.errorMessage
		}
    },
	methods: {
        login: function(){
			this.$store.dispatch('account/login',{
				'grant_type': this.grant_type,
				'username': this.username,
				'password': this.password,
				'client_id': this.client_id,
				'client_secret': this.client_secret,
			})
			.then( () => {
				this.username = ''
				this.password = ''
				this.password_confirm = ''
			})
        },
        register: function(){
            this.loading = true;
            //var vm = this;
            /*$.post('https://data.character.gallery/users/register',{
                'email':vm.username,
                'password':vm.password,
            }, function(data){
                vm.login();
            },'json') */
		},
    },

}
</script>

<style scoped>

</style>